export const ACCEPT_PAP = "ACCEPT_PAP";
export const REJECT_PAP = "REJECT_PAP";
export const SET_SHOW_PAP = "SET_SHOW_PAP";

export const acceptPap = () => ({
	type: ACCEPT_PAP,
});

export const rejectPap = () => ({
	type: REJECT_PAP,
});

export const setShowPap = (bool) => ({
	type: SET_SHOW_PAP,
	bool
});
